import layout1Settings from "./Layout1/Layout1Settings";  
import { themeColors } from "./EgretTheme/themeColors";
import { themeColorsDark } from "./EgretTheme/themeColorsDark";
import { createTheme } from "@material-ui/core/styles";
import { forEach, merge } from "lodash";
import themeOptions from "./EgretTheme/themeOptions";
  
// function createEgretThemes() {
//   let themes = {};

//   forEach(themeColors, (value, key) => {
//     themes[key] = createTheme(merge({}, themeOptions, value));
//   });
//   return themes;
// }
// let themes = createEgretThemes();

function createEgretThemes(themeColorsName) {
  let themes = {};

  forEach(themeColorsName, (value, key) => {
    themes[key] = createTheme(merge({}, themeOptions, value));
  });
  return themes;
}

let themes = createEgretThemes(themeColors);


if(localStorage.getItem("theme")==='dark'){
  themes = createEgretThemes(themeColorsDark);
}

export const EgretLayoutSettings = {
  activeLayout: "layout1", // layout1
  activeTheme: "purple1", // View all valid theme colors inside EgretTheme/themeColors.js


  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js 


  secondarySidebar: {
    show: true,
    theme: "slateDark1" // View all valid theme colors inside EgretTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: false,
    fixed: false,
    theme: "slateDark1" // View all valid theme colors inside EgretTheme/themeColors.js
  }
};
 